import { makeSheetRowData, makeSheetRowDataWithPreDefinedRows } from "../../helpers/RowHelper";
import { PATCH, POST } from "../../service/axiosMethods"
import { ELASTIC_URL } from "../../utils/apiConstant"
import store from "../store";
import ACTION_TYPES from "../types";
import { renderAlert } from "../../CommonComponents/Alert/Alert";
import { v4 as uuidv4 } from 'uuid';
import { capitalizeFirstLetter, partialRefresh, removeTimeSeriesColumns, returnUserAndTimeStampFromLastUpdatedByUser } from "../../helpers/helper";
import { deleteEventsOnDeleteSheet, fetchSharedLists, getAccessInfoByEntityIdForSharedSheet, getSharedListById, updateAccessInStore, 
    uploadWorbookToOneDriveIfNotAlready } from "./userActivityAction";
import { getProjectTemplateColumns, RollupListColumns } from "../../utils/constantData";
import { TotalColumnTimeSeriesListData } from "../../MiniProducts/xTables/cellComponents/FushionColumn/constants/MdvConstant";
import { SetTimeSeriesColumnProperties, getCellClass, getCellStyle, getStartAndEndDate, returnSharedWorkbookObject } from "../../MiniProducts/xTables/helper/helperFunctions";
import dayjs from "dayjs";
import { checkSheetToDownloadInAWorkbook, createExcelJsWorkbook, cropStringIfNameExceeds31Chars } from "../../helpers/ExportHelper"; 
import { getDeactivatedWorkbooks, setIsSharedWorkbookFlag, updateWorkBookListInStoreAndSideBarIfWbDeleted } from "./workbookAction";
import { TimeSeriesColumngroup } from "../../MiniProducts/xTables/components/Grid/gridHelperFunctions";
import { deleteChildrenFromColumns } from "./currentSheetDataAction";
import { sendMail } from "../../helpers/mailHelper";
import XTABLES_ACTION_TYPES from "../../MiniProducts/xTables/redux/xTablesReduxActionTypes";

export const internallySortSheetDocObj=(sheetDocObj)=>{
    Object.keys(sheetDocObj).forEach((sheet)=>{
        let singlesheet=sheetDocObj[sheet];
        singlesheet.sort((doc1,doc2)=>{return doc1.pageNo<doc2.pageNo})
        sheetDocObj[sheet]=singlesheet;
    })
    return sheetDocObj
}

export const GetSheetListByWorkbookId = (workbookId, callback, preDefinedSheet, isSharedWorkbook, navigate) => async (dispatch) => {
    try {
        let sheetIdListFromDb = [];
        let sheetList=[]
        let sheetDocObj={}
        let {currentSelectedWorkbook,workbookListData, sharedWithMeWorkBooks}=store.getState().workbookReducer
        let {userData}=store.getState().userReducer
        const sheetIndex = window.SHEET_INDEX;
        const res = await POST(`${ELASTIC_URL}/sheet/searchByWorkbookId`, { index: sheetIndex, workbook_id: `${workbookId}`, loggedInUser:`${userData.email}` });
        if(res.data.length === 0){
            const isWbDeactivated = await getDeactivatedWorkbooks([`${workbookId}`]);
            if(isSharedWorkbook && isWbDeactivated.length > 0){
                renderAlert("Workbook has been deleted, Redirecting to My Workbooks",'error',2000);
                dispatch(navigateToMyWorkbooksIfSharedSheetNotFound(navigate,true));
                return;
            }else if(isWbDeactivated.length > 0){
                dispatch(updateWorkBookListInStoreAndSideBarIfWbDeleted(workbookId));
                renderAlert("Workbook has been deleted, Redirecting to My Workbooks",'error',2000);
                if(navigate)
                dispatch(navigateToMyWorkbooks(false,navigate));
                return;
            }
        }
        
        if(res) {
           res && res.data && res.data.length && res.data.forEach((sheet) => {
               if (sheet._source.workbook_id === workbookId) {
                if (!sheet._source.sheet_identifier || (sheet._source.sheet_identifier && sheet._source.pageNo === 1)) {
                    let obj = { index: sheet._index, id: sheet._id, columnDefs: sheet._source.columns, ...sheet._source }
                    sheetList.push(obj)
                    sheetIdListFromDb.push(sheet._id);
                    localStorage.setItem('mD_' + sheet._id, JSON.stringify({ name: sheet._source.name, wb_name: currentSelectedWorkbook.name, loggedInUser: userData.email, sheetOwner: sheet._source.user_email }))
                    localStorage.setItem('mD_' + sheet._source.sheet_identifier, JSON.stringify({ name: sheet._source.name, wb_name: currentSelectedWorkbook.name, loggedInUser: userData.email, sheetOwner: sheet._source.user_email }))
                }
                if (sheetDocObj[sheet._source.sheet_identifier]) sheetDocObj[sheet._source.sheet_identifier].push({ id: sheet._id, ...sheet._source })
                else sheetDocObj[sheet._source.sheet_identifier] = [{ id: sheet._id, ...sheet._source }]
            }   
           })

        }
        let sortedSheetDocObj=internallySortSheetDocObj(sheetDocObj)

        const workbookForSort = isSharedWorkbook
            ? sharedWithMeWorkBooks.find(wb => wb.id === workbookId)
            : workbookListData.find(wb => wb.id === workbookId);
        if (workbookForSort?.orderSheetListIds?.length) {
            const orderMap = new Map(workbookForSort.orderSheetListIds.map((id, idx) => [id, idx]));
            sheetList.sort((a, b) => {
                const aIdx = orderMap.has(a.id) ? orderMap.get(a.id) : Infinity;
                const bIdx = orderMap.has(b.id) ? orderMap.get(b.id) : Infinity;
                return aIdx - bIdx;
            });
        }

        if(res && res.data.length === 0) {
           await dispatch(addSheetIfWorkbookIsEmpty(currentSelectedWorkbook, workbookId, sheetList));
        }
        
        isSharedWorkbook ?
        sharedWithMeWorkBooks.forEach((workbook, index) => {
            if (workbook.id === workbookId) {
                workbook.sheetList = sheetList
            }
        })
        :
        workbookListData.forEach((workbook, index) => {
            if (workbook.id === workbookId) {
                workbook.sheetList = sheetList
            }
        })
        
        let newlySelectedWb;
        if (isSharedWorkbook) {
            if (sharedWithMeWorkBooks.length === 0) {
                newlySelectedWb = await dispatch(returnSharedWorkbookObject(workbookId, userData, sheetList));
            } else {
                newlySelectedWb = sharedWithMeWorkBooks.find(item => item.id === workbookId);
            }
        } else {
            newlySelectedWb = workbookListData.find(item => item.id === workbookId);
            if(newlySelectedWb?.copyOfOriginal){
                 newlySelectedWb.l_id=newlySelectedWb.templateScope == "public"?'publicTemplates.' + newlySelectedWb.l_id.split('.').slice(-1):'privateTemplates.' + newlySelectedWb.l_id.split('.').slice(-1);
                  newlySelectedWb.parent= newlySelectedWb.templateScope == "public"?'publicTemplates':'privateTemplates';
                  newlySelectedWb.name = newlySelectedWb.templateName|| newlySelectedWb.name;
                  newlySelectedWb.workspace_id = "";
                sheetList.forEach(sheet=>{
                    if(!sheet.copyOfOriginal){
                    sheet.copyOfOriginal = true;
                    sheet.workspace_id = "";
                    if(sheet.l_id){
                        sheet.l_id = newlySelectedWb.l_id+"."+sheet.id
                    }}
                })

            }
        } 
        let { isOneDriveConnected } = store.getState().userActivityReducer;

        let { currentDownladingWorkbook, exportWorkbook, isWorkbookDownloading } = store.getState().workbookReducer;
        const isExportingAlreadyOngoing = ((currentDownladingWorkbook && Object.keys(currentDownladingWorkbook).length > 0) || (exportWorkbook && Object.keys(exportWorkbook).length > 0))
        
        //check if any workbook is already exporting if yes then stop this one 
        
        if (isOneDriveConnected && !isExportingAlreadyOngoing) setTimeout(() => dispatch(
            uploadWorbookToOneDriveIfNotAlready(
                workbookId, 
                newlySelectedWb
                )
            ), 3000);
        dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, workbookListData: workbookListData, currentSelectedWorkbook: newlySelectedWb, selectedWorkbookId: workbookId, isSharedWorkbook : isSharedWorkbook })
        dispatch({ type: ACTION_TYPES.GET_SHEET_DATA, payload: sheetList, itemId: sheetIdListFromDb, sheetDocObj: sortedSheetDocObj })
        let selectedSheet
        if(preDefinedSheet){
            selectedSheet=sheetList.filter((sheet)=>sheet.id===preDefinedSheet)
            if(selectedSheet.length > 0) {
                selectedSheet=selectedSheet[0]
            }
            else selectedSheet=sheetList[0]
        }
        else selectedSheet=sheetList[0]
        if(callback)callback(sheetList, selectedSheet)
    } catch (error) {
        console.log(error)
    }
}

export const handleMoveCopySheet = (selectedSheet, updatedSheet, targetWorkbook, sheetLists, updatedOrderedSheetListIds, isCopy) => async (dispatch) => {
    try {
          
        const payload = {
            originalSheetId: selectedSheet.id,
            targetWorkbookId: targetWorkbook.id,
            newSheetId: updatedSheet.id,
            newSheetIdentifier: updatedSheet.sheet_identifier,
            newSheetName: updatedSheet.name
        };

        if(updatedSheet.sheetType ==='filterSheet'){
            payload.Rows = updatedSheet.Rows,
            payload.sheetTypeSpecificInfo = updatedSheet.sheetTypeSpecificInfo,
            payload.sheetType = updatedSheet.sheetType,
            payload.namedFilters = updatedSheet.namedFilters
        }

        let response = [];

        if (isCopy) {
            if (selectedSheet.user_email !== targetWorkbook.user_email) {
                payload.user_email = targetWorkbook.user_email;
                payload.user_id = targetWorkbook.user_email;
              }
            if (selectedSheet.workspace_id !== targetWorkbook.workspace_id) {
                payload.workspace_id = targetWorkbook.workspace_id
            }
            response = await POST(`${ELASTIC_URL}/sheet/clone`, payload);
        } else if (selectedSheet.workbook_id !== targetWorkbook.id) {
            const doc = {
                workbook_id: targetWorkbook.id,
                l_id: `${targetWorkbook.l_id}.${selectedSheet.id}`,
                parent: targetWorkbook.id,
                name: updatedSheet.name
            };

            if (selectedSheet.user_email !== targetWorkbook.user_email) {
                doc.user_email = targetWorkbook.user_email;
                doc.user_id = targetWorkbook.user_email;
            }
            if (selectedSheet.workspace_id !== targetWorkbook.workspace_id) {
                doc.workspace_id = targetWorkbook.workspace_id
            }
            response = await POST(`${ELASTIC_URL}/sheet/update`, {
                sheetId: selectedSheet.id,
                doc
            });
        }
        if (response) {
            if (isCopy) {
                const updatedSheetList = sheetLists.map((sheet)=>{
                    if(sheet.id===response.data.id && sheet.sheetType ==="rolluplist")
                    {
                        sheet.name = response.data.name              
                    }
                    return sheet;
                })
                 
                await dispatch({
                    type: ACTION_TYPES.SET_WORKSPACE_DATA,
                    rowDataEditor: {
                        action: "copySheet",
                        workbook: { sheetList: updatedSheetList, id: targetWorkbook.id, user_email: targetWorkbook.user_email, copyOfOriginal:targetWorkbook?.copyOfOriginal, templateScope: targetWorkbook?.templateScope || targetWorkbook.template_scope, workspace_id : targetWorkbook.workspace_id, targetWorkbook_l_id : targetWorkbook.l_id   }
                    }
                });
                await dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: response.data.updateddate })
                await dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, createdDateOfSheet: response.data.created_date })

            } else {
                await dispatch({
                    type: ACTION_TYPES.SET_WORKSPACE_DATA,
                    rowDataEditor: {
                        action: "moveSheet",
                        workbook: { sheetList: sheetLists, id: targetWorkbook.id, user_email: targetWorkbook.user_email, workspace_id : targetWorkbook.workspace_id, targetWorkbook_l_id : targetWorkbook.l_id  },
                        sheet: { selectedSheet }
                    }
                });
            }

            await dispatch(updatedreorderedSheetList(updatedOrderedSheetListIds, targetWorkbook.id));

            // Ensure you return a Promise or something that resolves asynchronously
            return Promise.resolve(response.data?.message || "Sheet move/copy successful");
        } else {
            throw new Error(response.data?.message || "Unknown error occurred");
        }
    } catch (error) {
        console.error("Error in handleMoveCopySheet:", error);
        throw new Error(error?.response?.data?.message || "Failed to move/copy sheet");
    }
};

export const updatedreorderedSheetList = (orderSheetListIds, WorkBookId) => async (dispatch) => {
    const workbookPayload = { doc: { orderSheetListIds }, id: WorkBookId, index: "workbook" };
    const body = JSON.stringify(workbookPayload);

    try {
        const res = await POST(`${ELASTIC_URL}/update`, body);

        if (res?.data) {
            return Promise.resolve(res.data);
        } else {
            console.error("Failed to update sheet list:", res?.message);
            return Promise.reject(res?.message || "Unknown error");
        }
    } catch (error) {
        console.error("Error updating sheet list:", error);
        return Promise.reject(error);
    }
};

export const updateSharedSheetInStore = (sheetId, navigate, redirectToMyWbs=true) => async(dispatch) => {
    try {
        const {sharedWithMeSheets} = store.getState().userActivityReducer;
        const { workbookListData } = store.getState().workbookReducer;
        const { userData } = store.getState().userReducer;

        await removeLockFromSheet(sheetId);
        let updatedSheets = sharedWithMeSheets.filter((sheet) => sheet.id !== sheetId);
        dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, sharedWithMeSheets: updatedSheets });
        dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {action:"deleteSheet",sheet:{id:sheetId}} });
        const accessKey = `${userData.email}_${sheetId}`;
        dispatch(updateAccessInStore(accessKey));
        dispatch({type:ACTION_TYPES.SET_ISSHARED, isShared:false})

        if(redirectToMyWbs)
        dispatch(navigateToMyWorkbooks(false, navigate));
    } catch (error) {

        console.log("Error in updateSharedSheetInStore in sheetAction.js", error);
    }
}

export const getSheetListByWorkbookIdForSharedSheetOnRefresh = (workbook, sheet_identifier, userData, callback) => async (dispatch) => {
    let sheetIdListFromDb = [];
    let sheetList = [];
    let sheetDocObj = {};
    const sheetIndex = process.env.SHEET_INDEX;
    const res = await POST(`${ELASTIC_URL}/sheet/searchByWorkbookId`, { index: sheetIndex, workbook_id: `${workbook.id}`, loggedInUser:`${userData.email}` });
    if(res){
        res && res.data && res.data.length && res.data.forEach((sheet) => {
            if (sheet._source.workbook_id === workbook.id) {
                if (!sheet._source.sheet_identifier || (sheet._source.sheet_identifier && sheet._source.pageNo === 1)) {
                    let obj = { index: sheet._index, id: sheet._id, columndefs: sheet._source.columns, ...sheet._source }
                    sheetList.push(obj)
                    sheetIdListFromDb.push(sheet._id);
                    localStorage.setItem('mD_' + sheet._id, JSON.stringify({ 
                        name: sheet._source.name, 
                        wb_name: workbook.name, 
                        loggedInUser: userData.email, 
                        sheetOwner: sheet._source.user_email
                    }))
                    localStorage.setItem(
                        'mD_' + sheet._source.sheet_identifier,
                        JSON.stringify({
                             name: sheet._source.name, 
                             wb_name: workbook.name, 
                             loggedInUser: userData.email, 
                             sheetOwner: sheet._source.user_email 
                            }))
                }
                if (sheetDocObj[sheet._source.sheet_identifier]) sheetDocObj[sheet._source.sheet_identifier].push({ id: sheet._id, ...sheet._source })
                else sheetDocObj[sheet._source.sheet_identifier] = [{ id: sheet._id, ...sheet._source }]
            }
        });
        let sortedSheetDocObj=internallySortSheetDocObj(sheetDocObj)
        workbook.sheetList = sheetList;
        dispatch

        const currentSheet = sheetList.find(sheet => sheet.sheet_identifier === sheet_identifier);
        console.log('currentSheet------', currentSheet);
        dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, currentSelectedWorkbook: workbook, selectedWorkbookId: workbook.id, isSharedWorkbook : true });
        dispatch({ type: ACTION_TYPES.GET_SHEET_DATA, payload: sheetList, itemId: sheetIdListFromDb, sheetDocObj: sortedSheetDocObj })
        if(callback) {
            callback(currentSheet, sheetList);
        };
    }

}

export const addSheetIfWorkbookIsEmpty = (currentSelectedWorkbook, workbookId, sheetList ,callbackFunctionToAddSheetInSheetList) => async(dispatch) =>{
    
    dispatch({type: ACTION_TYPES.EMPTY_SHEET_HANDLEING,  sheetListData: [], sheetLoader:false,currentSelectedSheet:null})
            renderAlert("Creating a new sheet for you as the workbook is empty", "success", "3000")
            let sheetName = "Sheet (1)"
            let sheetId = 'sh_' + uuidv4();
            let sheet_l_id = currentSelectedWorkbook.l_id + "." + sheetId;
            let sheetType = "default"
            let workspace_id=currentSelectedWorkbook.parent;
            let createdSheetInfo;

            await dispatch(createSheetHelperForWorkSpaces({
                sheetName, sheetId, sheetType, workspace_id, l_id: sheet_l_id, workbook_id: workbookId, parent: workbookId,
                newWorkbook_l_id: '', callback: (res, sheetInfo) => {
                    createdSheetInfo = sheetInfo.doc
                    sheetList.push(createdSheetInfo)
                    if(callbackFunctionToAddSheetInSheetList) callbackFunctionToAddSheetInSheetList(sheetList[0],sheetList)
                }
            }))
}

export const selectSheetFromAnotherWorkbook=(workbook_id,sheet_id,allSheets) =>async (dispatch) => {
    const { workbookListData } = store.getState().workbookReducer
    let changedWorkbook = workbookListData.filter((workbook) => workbook.id === workbook_id);
    if (changedWorkbook && changedWorkbook.length) changedWorkbook = changedWorkbook[0]
    changedWorkbook.sheetList = allSheets?.filter(item => item?.workbook_id === workbook_id);
    dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, selectedWorkbookId: changedWorkbook.id, currentSelectedWorkbook: changedWorkbook })
    dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, sheetListData: changedWorkbook.sheetList, sheetListId: changedWorkbook?.sheetList?.map((sheet) => sheet.id),selectedSheetId: sheet_id })
    // dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader:true })
    let selectedSheet = changedWorkbook?.sheetList?.filter((sheet) => sheet.id === sheet_id)
    return;
    // if (callback && selectedSheet[0]) callback(selectedSheet[0], changedWorkbook.sheetList)
}
export const searchBySheetId = (id, user, callback, sheet, updateTimeStamp=true) => async (dispatch) => {
    // 20/5/25 updateTimeStamp should be false while export wb/ onedrive upload 
    let res
    let updatedSheet
    if (sheet && sheet === "sheetNotFound") {
        updatedSheet = await POST(ELASTIC_URL + '/sheet/searchBySheetId', { id, user_id: user.email })

        if (updatedSheet?.data?.sheetType === 'checkinagent') {
            res = await POST(ELASTIC_URL + '/sheet/getCheckinAgentSheet', {
                sheet_id: updatedSheet?.data?.id, referenceSheetId: updatedSheet.data.referenceSheetId, sheet_identifier: updatedSheet?.data?.sheet_identifier
            })
        }
        else {
            res = updatedSheet
        }
        if(updateTimeStamp)
        dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: res?.data?.updateddate || '' })
    }
    else {
        if (sheet && sheet.sheetType === 'checkinagent') {
            res = await POST(ELASTIC_URL + '/sheet/getCheckinAgentSheet', {
                sheet_id: sheet.id, referenceSheetId: sheet.referenceSheetId, sheet_identifier: sheet.sheet_identifier
            })
        }
        else {
            res = await POST(ELASTIC_URL + '/sheet/searchBySheetId', { id, user_id: user.email })
        }
        if(updateTimeStamp)
        dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: res?.data?.updateddate || ''})
    }
    if (res && res.data === "Sheet doesn't exist") {
        renderAlert("Sheet doesn't exist", 'error')
        dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false })
    }
    else if (callback) {
        dispatch({ type: ACTION_TYPES.SET_UPDATED_TIME, updatedNotesTimeStamp: res?.data?.updatedNotesTimeStamp || ""})
        callback(res.data)
    }
}

export const checkIfWorkbookOfTheSheetIsShared = (sheet, isSharedWorkbook) => async (dispatch) => {
    const { accessInfo } = store.getState().userActivityReducer;
    const { user } = store.getState().userReducer;
    const accessKey = user + '_' + sheet.workbook_id;
    const access = accessInfo.get(accessKey);
    
    if (access && !isSharedWorkbook) {
        dispatch({ type: ACTION_TYPES.SET_SHARED_SHEET, payload: true, selectedSheetId: '', currentSelectedSheet: sheet, sheetDocObj: {}, isSharedWorkbook: true });
    }
}

export const deleteSheet = ({
    sheet,
    key,
    callback,
    isSheetFromCurrentWorkbook = true,
    isDeleteWorkspace,
    calendarEvents,
    navigate,
    checkinagentSheet,
    currentSelectedSheet,
    isCurrentSheet
}
) => async (dispatch) => {
    try {
         
        const { isShared } = store.getState().sheetReducer;
        const payload = createPayload(sheet);
        payload.userSession = store.getState().userReducer.myCurrentSession;
        const {selectedWorkbookId, workbookListData, currentSelectedWorkbook} = store.getState().workbookReducer;
        const response = await POST(`${ELASTIC_URL}/sheet/delete`, payload);
        if (!response) return;

        if (handleResponseErrors(response, dispatch, isDeleteWorkspace)) return;

        if (sheet.sheetType === 'xPad') {
            dispatch(deleteEventsOnDeleteSheet(sheet.id, calendarEvents));
        }

        if (isShared) {
            handleSharedSheet(dispatch, navigate);
            return;
        }

        const { sheetListData, sheetListId } = store.getState().sheetReducer;
        const sheetsToDelete = getSheetsToDelete(sheet.id, checkinagentSheet);
        const { newSheetList, newSheetIdList } = filterSheets(sheetListData, sheetListId, sheetsToDelete);

        if (!isSheetFromCurrentWorkbook) return;

        const updatedWorkbook = {
            ...currentSelectedWorkbook,
            orderSheetListIds:[...newSheetIdList],
            sheetList:[...newSheetList]
        }

        dispatch(deleteSheetItem(sheet, newSheetList, newSheetIdList, currentSelectedSheet));
        scheduleWorkspaceUpdate(dispatch, sheet.id, newSheetList, updatedWorkbook);

        if (typeof callback === "function") {
            executeCallback(callback, newSheetList, isCurrentSheet);
        }

    } catch (error) {
        renderAlert("Error in deleting sheet", error);
    }
};

const handleResponseErrors = (response, dispatch, isDeleteWorkspace) => {
    if (typeof response.data === 'string') {
        if (response.data.includes('locked') || response.data.includes('session')) {
            renderAlert(response.data, 'error');
            dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
            return true;
        } else if (!isDeleteWorkspace) {
            renderAlert(response.data, 'success');
        }
    }
    return false;
};
const handleSharedSheet = (dispatch, navigate) => {
    renderAlert("Redirecting to My Workbooks", "info", 1000);
    dispatch(navigateToMyWorkbooksIfSharedSheetNotFound(navigate));
};

const getSheetsToDelete = (sheetId, checkinagentSheet) => {
    return [...new Set([sheetId, checkinagentSheet?.id].filter(Boolean))];
};

const filterSheets = (sheetListData, sheetListId, sheetsToDelete) => {
    return {
        newSheetList: sheetListData?.filter(sheetVal => !sheetsToDelete.includes(sheetVal.id)),
        newSheetIdList: sheetListId?.filter(sheetVal => !sheetsToDelete.includes(sheetVal))
    };
};

const deleteSheetItem = (sheet, newSheetList, newSheetIdList, currentSelectedSheet) => ({
    type: ACTION_TYPES.DELETE_SHEET_ITEM,
    newSheetList,
    newSheetIdList,
    currentSelectedSheet : sheet.id !== currentSelectedSheet.id ? currentSelectedSheet : undefined 
});

const scheduleWorkspaceUpdate = (dispatch, sheetId, newSheetList, updatedWorkbook) => {
     
    setTimeout(() => {
        dispatch({
            type: ACTION_TYPES.SET_WORKSPACE_DATA,
            rowDataEditor: { action: "deleteSheet", sheet: { id: sheetId },  }
        });
        dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, currentSelectedWorkbook : updatedWorkbook })
    }, 1000);
};

const executeCallback = (callback, newSheetList, isCurrentSheet) => {
    callback(
        newSheetList.length === 0 || !isCurrentSheet  ? '' : newSheetList[0],
        newSheetList.length === 0 ? '' : newSheetList,
        newSheetList.length === 0
    );
};

const createPayload = (sheet) => {
    const { id, user_email, workbook_id, parent, name } = sheet;

    const payload = {
        id,
        user_email,
        workbook_id: workbook_id ?? parent
    };

    if (id) {
        const metaKey = `mD_${id}`;
        const metaData =
            localStorage.getItem(metaKey) ??
            JSON.stringify({
                name: name,
                wb_name: workbook_id,
                loggedInUser: user_email,
                sheetOwner: user_email
            });

        payload.metaData = metaData;
    }

    return payload;
};

export const updateSheetReducerIfSheetFoundDeleted = (sheet, callback) => async(dispatch) =>{
    try {
        const {sheetListData,sheetListId}=store.getState().sheetReducer;

        const newSheetList=sheetListData.filter((sheetVal)=>{
            return sheetVal.id !== sheet.id
        })
        const newSheetIdList=sheetListId?.filter((sheetVal)=>{
            return sheetVal !== sheet.id
        })

        setTimeout(() => {
            if(newSheetList.length===0)
            {
                dispatch({type: ACTION_TYPES.DELETE_SHEET_ITEM, newSheetList,newSheetIdList ,currentSelectedSheet:[]})
                dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {action:"deleteSheet",sheet:{id:sheet.id}} })
                
                callback('','',true,sheet.workbook_id)
                return
            }
            dispatch({type: ACTION_TYPES.DELETE_SHEET_ITEM,  newSheetList,newSheetIdList})
            dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {action:"deleteSheet",sheet:{id:sheet.id}} })
            callback(newSheetList[0],newSheetList)
          
        }, 1000);

    } catch (error) {
        console.log('Error in updateSheetReducerIfSheetFoundDeleted', error);
        
    }
}

const updateSharedSheetInSidebarIfSheetFoundDeleted = (sheet) => async(dispatch) => {
    try {
        dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {action:"deleteSheet",sheet:{id:sheet.id}} })
    } catch (error) {
        console.error("Error in updateSharedSheetInSidebarIfSheetFoundDeleted", error);
    }
 }

export const navigateToMyWorkbooksIfSharedSheetNotFound = (navigate, isSharedWorkbook, sheet) => async(dispatch) =>{
    try {
        const {selectedWorkbookId, workbookListData} = store.getState().workbookReducer;
        if(sheet)
        dispatch(updateSharedSheetInSidebarIfSheetFoundDeleted(sheet))
        if (selectedWorkbookId && !isSharedWorkbook) {
            dispatch(GetSheetListByWorkbookId(workbookListData[0].id,
                 (sheetList, sheet) => {
              navigate(`/sheet/${sheet.sheet_identifier}`)
              dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true })
              setTimeout(() => {
                dispatch({ type: ACTION_TYPES.SET_SHARED_SHEET, payload: false, selectedSheetId: sheet.id, currentSelectedSheet: sheet, sheetListData: sheetList })
              }, 500)
            }, undefined, false, navigate))
        }else{
           dispatch(navigateToMyWorkbooks(isSharedWorkbook, navigate));

        }
    } catch (error) {
        console.log("Error in navigateToMyWorkbooksIfSharedSheetNotFound", error);
        
    }
}

export const navigateToMyWorkbooks = (isSharedWorkbook, navigate) => async (dispatch) => {
    try {
        const { workbookListData } = store.getState().workbookReducer;
        if (isSharedWorkbook) {
            dispatch(setIsSharedWorkbookFlag(false));
        }
        setTimeout(() => {
            dispatch(GetSheetListByWorkbookId(workbookListData[0].id,
                 (sheetList, sheet) => {
                navigate(`/sheet/${sheet.sheet_identifier}`)
                dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true })
                setTimeout(() => {
                    dispatch({ type: ACTION_TYPES.SET_SHARED_SHEET, payload: false, selectedSheetId: sheet.id, currentSelectedSheet: sheet, sheetListData: sheetList })
                }, 500)
            }, undefined, false, navigate))
        }, 50);
    } catch (error) {
        console.error("Error in navigateToMyWorkbooks", error);

    }
}
export const SaveMultiSheets = ({ newSheetArray, newWorkbook, workbook_id, sheetListId, currentSelectedSheet, newCols, sheetType, sheetList, uuid, rows, callback, justUpdateXPad, createdSheetCallback, isCurrentSheet = true }) => async (dispatch) => {
    try {
        let { userData } = store.getState().userReducer;
        let { currentSelectedWorkbook } = store.getState().workbookReducer;

        // Exit if just updating xPad (not needed here)
        if (justUpdateXPad) return;

        // Prepare sheets for insertion
        let sheetsToInsert = [];

        for (let sheet of newSheetArray) {
            // Add default styles if it's a new sheet
            let globalStyle = {
                format: {
                    bold: false,
                    underline: false,
                    italic: false,
                    strikethrough: false
                },
                cellStyle: {
                    backgroundColor: "transparent",
                    fontFamily: "Arial",
                    fontSize: "12px",
                    color: "black"
                }
            };

            sheet.doc = { ...sheet.doc, globalStyle };
            dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });
            // Prepare row data for the sheet
            const rowData = rows ?
                makeSheetRowDataWithPreDefinedRows({
                    user_id: userData.user_id || userData.email,
                    user_email: userData.email,
                    uuid,
                    workbook_id,
                    rows,
                    sheetType
                })
                :
                makeSheetRowData({
                    user_id: userData.user_id || userData.email,
                    user_email: userData.email,
                    uuid,
                    workbook_id
                });

            // Set row data to the sheet if needed
            if (sheet.doc.sheetType !== 'xPad' && sheet.doc.sheetType !== 'view') sheet.doc.Rows = rowData;

            sheetsToInsert.push(sheet);
        }
        // Send all sheets in a single request
        let url = "/sheet/insertMultipleSheets"; // Assuming the endpoint accepts an array of sheets
        let response = await POST(ELASTIC_URL + url, JSON.stringify(sheetsToInsert));
        let newSheetDataElasticFornavigation;
        // Check if the response is successful
        if (response && (response.error === undefined || response.error.statusCode === undefined)) {
            let newSheetsFromDB = response.data.sheets

            let sheetIdListCopy = [...sheetListId].reverse();
            let sheetListCopy = [...sheetList].reverse();
            const { sheetDocObj } = store.getState().sheetReducer;
            // Iterate over created sheets and update the list
            newSheetsFromDB.forEach((newSheetFromDB, index) => {
                if (sheetsToInsert[index]) {
                    sheetsToInsert[index].doc.name = newSheetFromDB.sheetName;
                }

                const newSheetDataElastic = { index: newSheetFromDB._index, id: newSheetFromDB._id, ...sheetsToInsert[index].doc }
                if (!newSheetDataElasticFornavigation && sheetsToInsert[index].doc.sheetType === 'project') newSheetDataElasticFornavigation = newSheetDataElastic
                sheetDocObj[newSheetDataElastic.sheet_identifier] = [newSheetDataElastic]
                delete newSheetDataElastic.Rows

                // Save metadata for the sheet
                localStorage.setItem('mD_' + newSheetFromDB._id, JSON.stringify({
                    name: sheetsToInsert[index].doc.name,
                    wb_name: currentSelectedWorkbook.name,
                    loggedInUser: userData.email,
                    sheetOwner: sheetsToInsert[index].doc.user_email
                }));

                localStorage.setItem('mD_' + sheetsToInsert[index].doc.sheet_identifier,
                    JSON.stringify({
                        name: sheetsToInsert[index].doc.name,
                        wb_name: currentSelectedWorkbook.name,
                        loggedInUser: userData.email,
                        sheetOwner: sheetsToInsert[index].doc.user_email
                    }))
                    
                dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "renameSheet", sheet: { name: sheetsToInsert[index].doc.name, id: sheetsToInsert[index].id } } })
            });

            // Update the Redux store with the new list of sheets
            dispatch({ type: ACTION_TYPES.CREATE_NEW_SHEET, payload: sheetListCopy, newSheetListId: sheetIdListCopy, newWorkbook: newWorkbook, sheetDocObj })
            dispatch({
                type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {
                    action: "addMultipleSheets",
                    sheet: sheetListCopy
                }
            });
            // Call the main callback after all sheets are processed
            if (callback) callback();
        }
        // Call the callback for each new sheet
        if (createdSheetCallback && newSheetDataElasticFornavigation) createdSheetCallback(newSheetDataElasticFornavigation);
    } catch (error) {
        console.log("Error in saving new sheets", error);
    }
}

export const SaveSheet = ({ newSheet, newWorkbook, workbook_id, sheetListId, currentSelectedSheet, newCols, sheetType, sheetList, uuid, rows, callback, justUpdateXPad, createdSheetCallback, isCurrentSheet = true }) => async (dispatch) => {
    try{
      
        let isNewSheet = newSheet ? true : false;
        let sheet = newSheet ? newSheet : currentSelectedSheet;
        let sheet_id = sheet?.doc?.id;
        let { userData } = store.getState().userReducer;
        let { currentSelectedWorkbook } = store.getState().workbookReducer;
        if (isNewSheet)
        {
            let globalStyle = {
                format: {
                    bold: false,
                    underline: false,
                    italic: false,
                    strikethrough: false
                },
                cellStyle: {
                    backgroundColor: "transparent",
                    fontFamily: "Arial",
                    fontSize: "12px",
                    color: "black"
                }
            }
            newSheet.doc = { ...newSheet.doc, globalStyle }
        }
        if (currentSelectedSheet && currentSelectedSheet.sheetType === 'xPad') {
            let content=localStorage.getItem(`xPadContent_${currentSelectedSheet.id}`)
            uploadxPadContent({content,sheet_id:currentSelectedSheet.id})
        }
        if (justUpdateXPad) return
        
        if(sheet){
            let url = isNewSheet ? "/sheet/insertDoc" : '/update';
            let response
            if(isNewSheet){
                dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });
                let reqBody = sheet;
                
                const rowData = rows ? 
                    makeSheetRowDataWithPreDefinedRows({
                        user_id: userData.user_id || userData.email,
                        user_email: userData.email,
                        uuid,
                        workbook_id,
                        rows,
                        sheetType,
                        newCols
                    })
                    :
                    makeSheetRowData({
                        user_id: userData.user_id || userData.email,
                        user_email: userData.email,
                        uuid,
                        workbook_id
                    })
                if (newSheet.doc.sheetType !== 'xPad' && newSheet.doc.sheetType !== 'view') {
                    reqBody.doc.Rows = rowData;
                    dispatch({ type: XTABLES_ACTION_TYPES.SET_UPDATEROWS, gridRowsForCardSync: rowData });
                }
                if (!reqBody.doc.workbook_id) {
                    renderAlert("Error in creating sheet, please refresh and try again","error")
                    dispatch({ type: ACTION_TYPES.SET_FALLBACKERROR, fallbackerror: new Error("Workbook data invalid") })
                    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
                     throw new Error("Workbook data invalid");
                }
                response = await POST(ELASTIC_URL + url, reqBody);
            }
            else {
                let payload = sheet;
                if (localStorage.getItem('mD_' + sheet.id)) payload.metaData = localStorage.getItem('mD_' + sheet.id);
                let body = payload;
                response = await PATCH(ELASTIC_URL + url, body);
            }
            if (response && (response.error === undefined || response.error.statusCode === undefined) && response) {
                if (sheet) {
                    if (isCurrentSheet === false) {
                        return;
                    }
                    
                    let newSheetFromDB = response.data;
                    if (isNewSheet) {
                        sheet.doc.name = newSheetFromDB.sheetName;
                    }
                    const newSheetDataElastic = { index: newSheetFromDB._index, id: newSheetFromDB._id, ...sheet.doc }
                    let sheetIdListCopy = [...sheetListId];
                    let sheetListCopy = [...sheetList];
                    const existingSheetIndex = sheetList.findIndex((sheet) => sheet.id === newSheetFromDB._id);
                    const existingSheet = sheetList[existingSheetIndex];
                    const { sheetDocObj, selectedSheetId } = store.getState().sheetReducer;
                    if(existingSheetIndex !== -1) {
                        const updatedSheet = {
                            ...existingSheet,
                            name: sheet.doc.name,
                        }
                        sheetListCopy[existingSheetIndex] = updatedSheet;
                        // if(selectedSheetId===updatedSheet.id){
                        //     await dispatch({type: ACTION_TYPES.CREATE_NEW_SHEET, currentSelectedSheet:updatedSheet})
                        // }
                        if (selectedSheetId === updatedSheet.id) {
                            await dispatch({ type: ACTION_TYPES.CREATE_NEW_SHEET, payload: sheetListCopy, newSheetListId: sheetIdListCopy, currentSelectedSheet: updatedSheet });
                        } else {
                            await dispatch({ type: ACTION_TYPES.CREATE_NEW_SHEET, payload: sheetListCopy, newSheetListId: sheetIdListCopy });
                        }
                        dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "renameSheet", sheet: { name: sheet.doc.name, id: sheet.id } } });
                        if (callback) callback();
                        return;
                    }
                    if(isNewSheet)
                    dispatch({
                        type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {
                            action: "addSheet",
                            sheet: {
                                id: newSheetFromDB._id,
                                name: sheet.doc.name,
                                workbook_id: currentSelectedWorkbook.id,
                                user_id: sheet.doc.user_id || userData.user_id || userData.email,
                                user_email: sheet.doc.user_email || userData.email,
                                sheetType: sheetType || "default",
                                parent: currentSelectedWorkbook?.id ?? "",
                                sheet_identifier: sheet.doc.sheet_identifier,
                                copyOfOriginal: sheet.doc.copyOfOriginal,
                                sheet_scope: sheet.doc.sheet_scope,
                                l_id : sheet.doc.l_id
                            }
                        }
                    });
                    sheetIdListCopy.push(newSheetFromDB._id);
                    sheetListCopy.push(newSheetDataElastic)
                    sheetDocObj[newSheetDataElastic.sheet_identifier] = [newSheetDataElastic]
                    delete newSheetDataElastic.Rows   
                       
                    if (isCurrentSheet) {
                        dispatch({ type: ACTION_TYPES.CREATE_NEW_SHEET, payload: sheetListCopy, newSheetListId: sheetIdListCopy, newWorkbook: newWorkbook, sheetDocObj })
                    }
                    if(isNewSheet){
                        if(response?.data){
                            dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: ''})
                            dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, createdDateOfSheet: response?.data?.created_date})
                            dispatch({ type: ACTION_TYPES.SET_UPDATED_TIME, updatedNotesTimeStamp: response?.data?.updatedNotesTimeStamp ||"" })


                        }                
                    }
                    if(createdSheetCallback)
                    setTimeout(() => {
                        createdSheetCallback(newSheetDataElastic)
                    }, 0)
                    if (newSheet) {
                        localStorage.setItem('mD_' + response.data._id, JSON.stringify({ name: newSheet.doc.name, wb_name: currentSelectedWorkbook.name, loggedInUser: userData.email, sheetOwner: newSheet.doc.user_email }))
                        localStorage.setItem('mD_' + newSheet.doc.sheet_identifier, JSON.stringify({ name: newSheet.doc.name, wb_name: currentSelectedWorkbook.name, loggedInUser: userData.email, sheetOwner: newSheet.doc.user_email }))
                    }
                }
            }
        }  
        
    }
    catch (error) {
        console.log("errror in getting sheet data from API", error);
        
    }
}

export const uploadxPadContent=async({content,sheet_id,callback})=>{
    let sheetId=sheet_id ||store.getState().sheetReducer.selectedSheetId
    const {userData}=store.getState().userReducer
    let user = userData.email;
    let response=await PATCH(ELASTIC_URL+'/sheet/uploadxPadContent',{content,sheetId,user})
    if(response && response.data=="Error in Saving") renderAlert("Sorry. We could not save your progress. Refresh or try again later.","error")
    if(callback) callback(response)
}
export const addAttachmentsToSheet = (files,sheet) => async (dispatch) => {
    try {
        const formData = new FormData();
        files.forEach((file) => {
          formData.append('files', file,file.name);
        });
        formData.append('sheetId',sheet.id)
        const response = await POST(`${ELASTIC_URL}/sheet/uploadAttachmentsToSheet`,formData);
        if(response) {
            let attachments=sheet.attachments ? [...sheet.attachments,...response.data.attachments]:response.data.attachments;
            dispatch({type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: {...sheet,attachments}})
        }
        
    } catch (error) {
        console.log("error in deleting sheet", error);
    }
}
export const removeAttachmentsFromSheet = (file,sheet) => async (dispatch) => {
    try {
        let updatedAttachaments=sheet.attachments.filter((att)=>att.url!==file.url)
        let payload={sheetId:sheet.id,file:file.url}
        if(localStorage.getItem('mD_'+sheet.id)) payload['metaData']=localStorage.getItem('mD_'+sheet.id)
        const response = await POST(`${ELASTIC_URL}/sheet/remove/removeAttachmentFromSheet`,payload);
        if(response) {            
            dispatch({type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: {...sheet,attachments:updatedAttachaments}})
        }
        
    } catch (error) {
        console.log("error in deleting sheet", error);
    }
}
export const ShareSheet = (sheet,userToReceive,message,view,accessLevel,sharedByMeNotifications,callback) => async(dispatch)=>  {
    try {
            let newNotification={}
            const {userData}=store.getState().userReducer
            newNotification.notification_id=uuidv4()
            newNotification.recipient_id = userToReceive.email;
            newNotification.sender_id = userData.email;
            newNotification.entity_id=sheet.id
            newNotification.receiver_name=userToReceive.username
            if(userToReceive.email===userData.email){
                renderAlert("Sheet can't be shared with the same person which is signed In",'error')
                return
            } 
            newNotification.message = message;
            newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
            newNotification.notification_type ='Shared';
            newNotification.status = 'Not read';
            newNotification.view = view;
            newNotification.accesslevel = accessLevel;

            let metaData={
                sheet_id:sheet.id,sheetName:sheet.name,sheet_identifier:sheet.sheet_identifier,username:userData.name,type:sheet.sheetType === 'xPad'?'xPad':sheet.sheetType === 'view'?'view':'Grid'
            }
            newNotification.metadata=JSON.stringify(metaData)
            const response = await POST(`/notification/register/`,newNotification);
            if(response.status===201) { 
                
                sendMail({
                    username : userToReceive.username,
                    email : userToReceive.email
                },{
                    username : userData.name,
                    email : userData.email
                }, 
                newNotification.entity_id.startsWith("wb_"), 
                {
                    sheet_identifier : sheet.sheet_identifier,
                    name : view
                }
                )   
                callback("success")   
                sharedByMeNotifications.set(newNotification.notification_id,newNotification)
                let updatedNotifications=new Map(sharedByMeNotifications)
                dispatch({type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,sharedByMeNotifications:updatedNotifications})
            }
            else{
                callback("error")     
            }
        
    } catch (error) {
        callback(error)     
        console.log("error in sharing sheet", error);
    }
}
export const ShareSheetAccess = (sheet,sharedWith,access,advancedConfigurationToSend,viewName,accessInfo,callback) => async(dispatch)=> {
    try {  
        const handleuser=async(userToReceive)=>{
            let accessObj={}
            let accesses=[]
            const {userData}=store.getState().userReducer
            accessObj.id=userToReceive.email+"_"+sheet.id
            accessObj.user_id=userToReceive.email
            accessObj.entity_id=sheet.id
            accessObj.sender_id = userData.email;
            // accessObj.view=view
            if(userToReceive.email===userData.email){
                renderAlert("Sheet can't be shared with the same person which is signed In",'error')
                return
            } 
            accessObj.type = sheet.sheetType || 'Grid';
            accessObj.compound_object = false;
            accessObj.access_created = new Date(); // Set the timestamp to the current date/time
            accessObj.access_updated = new Date();      
            accessObj.receiver_name=userToReceive.username;   
            accessObj.view=viewName;
            for (let key in advancedConfigurationToSend) {
                let entityType = key // eg. columns
                advancedConfigurationToSend[key].forEach(({ access, selected }) => {                   
                    if (selected){ 
                        if(accessObj[capitalizeFirstLetter(access)]){
                            let obj=JSON.parse(accessObj[capitalizeFirstLetter(access)])
                            obj[entityType]=selected
                            accessObj[capitalizeFirstLetter(access)]=JSON.stringify(obj)
                        }else{
                        accessObj[capitalizeFirstLetter(access)] = JSON.stringify({ [entityType]: selected })}}

                        if(!accesses.includes(capitalizeFirstLetter(access))){
                            accesses.push(capitalizeFirstLetter(access))
                        }
                })
            }
            let highLevelAccessArr = ["2", "0", "0", "0"]
            if (advancedConfigurationToSend && Object.keys(advancedConfigurationToSend).length > 0) {
                if (accessObj.Read) highLevelAccessArr[0] = '1'
                else highLevelAccessArr[0] = "2"
                if (accessObj.Write && access.indexOf('write')!=-1) highLevelAccessArr[1] = "1"
                else {
                    if(access.indexOf('write')!=-1) {
                        highLevelAccessArr[1] = "2"
                        if (!accessObj.Write) accessObj.Write = 'Full'
                    }
                    else{
                        highLevelAccessArr[1] = "0"
                        accessObj.Write = 'None'
                    }
                }
                if (accessObj.Delete) highLevelAccessArr[3] = "1"
                else {
                    if (!accessObj.Delete && access.indexOf('delete')!=-1) {
                        accessObj.Delete = 'Full'
                        highLevelAccessArr[3]="2"
                    }
                    else accessObj.Delete = 'None'
                }
                if (accessObj.Share) highLevelAccessArr[2] = "1"
                else {
                    if (!accessObj.Share && access.indexOf('share')!=-1) {
                        accessObj.Share = 'Full'
                        highLevelAccessArr[2]="2"
                    }
                    else accessObj.Share = 'None'
                }
            }
            else if (access.indexOf('admin') != -1) {
                highLevelAccessArr = ["2", "2", "2", "2"];
                accessObj.Read = 'Full',
                    accessObj.Write = 'Full',
                    accessObj.Delete = 'Full',
                    accessObj.Share = 'Full',
                    accessObj.admin = true;
                    accesses.push('Read', 'Write', 'Delete', 'Share')
            }
            else {
                if(access.indexOf('read')!=-1) {highLevelAccessArr[0] = "2"; if (!accessObj.Read) accessObj.Read = 'Full'; accesses.push('Read')}
                if(access.indexOf('write')!=-1) {
                highLevelAccessArr[1] = "2";
                highLevelAccessArr[0] = "2"; 
                if (!accessObj.Write) accessObj.Write = 'Full'
                if (!accessObj.Read) accessObj.Read = 'Full'
                accesses.push('Write')
                }
                else {highLevelAccessArr[1] = "0"
                if (!accessObj.Write) accessObj.Write = 'None'
                }
                if(access.indexOf('share')!=-1){ highLevelAccessArr[2] = "2"; if (!accessObj.Share) accessObj.Share = 'Full'; accesses.push('Share')}
                else{ highLevelAccessArr[2] = "0";  if (!accessObj.Share) accessObj.Share = 'None'}
                if(access.indexOf('delete')!=-1) {highLevelAccessArr[3] = "2";  if (!accessObj.Delete) accessObj.Delete = 'Full';else if(accessObj.Delete) highLevelAccessArr[3]='1'; accesses.push('Delete')}
                else {highLevelAccessArr[3] = "0" ; if (!accessObj.Delete) accessObj.Delete = 'None'}
                accessObj.admin = false;               
            }
            accessObj.highlevelaccess=highLevelAccessArr.join('')
            const response = await POST(`/access/register`,accessObj);
            if(response.status===201)
            {
                let accessLevel=accesses.join(' ')
                const accessInfoById=store.getState().userActivityReducer.accessInfoById
                const isSharedWorkbook=store.getState().workbookReducer.isSharedWorkbook
                let temp=[...accessInfoById]
                temp.push(accessObj)
                accessInfo.set(accessObj.id,accessObj)
                let updatedAccess=new Map(accessInfo)
                dispatch({type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,accessInfo:updatedAccess,accessInfoById:temp })
                if(isSharedWorkbook){
                    await dispatch(getAccessInfoByEntityIdForSharedSheet(sheet.id))
                }
                callback(accessLevel,userToReceive)
        }  
        }

        for(const userToReceive of sharedWith)
        {
            await handleuser(userToReceive);
        }
        
    } catch (error) {
        callback(error)     
    console.log("error in sharing sheet", error);
    }
}
const makeSheetSessionInactive=(sheeetSession)=>{
    let {user,timestamp}=returnUserAndTimeStampFromLastUpdatedByUser(sheeetSession)
    timestamp=new Date(1900, 4, 21, 10, 33, 30, 0)
    return user+'-%^'+timestamp
}
export const removeLockFromSheet=async(sheetId)=>{
    if(!sheetId) return
    const {userData,myCurrentSession}=store.getState().userReducer
    let inactiveSheetSession = makeSheetSessionInactive(myCurrentSession)
    let payload={ sheetId ,user:userData.email,userSession:myCurrentSession }
    if(localStorage.getItem('mD_'+sheetId)) payload.metaData=localStorage.getItem('mD_'+sheetId)

    POST(`${ELASTIC_URL}/sheet/removeLockFromSheet`,payload );
}
export const removeLockFromSheetIfUnauthorised=async(sheetId)=>{
    if(!sheetId) return
    const {userData}=store.getState().userReducer
    let payload={ sheetId ,user:userData.email }
    if(localStorage.getItem('mD_'+sheetId)) payload.metaData=localStorage.getItem('mD_'+sheetId)
    return await POST(`unauthorised${ELASTIC_URL}/sheet/removeLockFromSheet`,payload );
}
export const removeLockManually = (sheetId) => async (dispatch) => {
    if (!sheetId) return
    const { userData } = store.getState().userReducer
    // dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: {...currentSelectedSheet,locked:userData.email,lastUpdatedByUser} });
    let payload = { sheetId, user: userData.email }
    const res = await POST(`${ELASTIC_URL}/sheet/removeLockManually`, payload);
    dispatch(partialRefresh())
    renderAlert('Removed lock from sheet', "success")
    if (localStorage.getItem('mD_' + sheetId)) payload.metaData = localStorage.getItem('mD_' + sheetId)

}
export const defaultSheetColumns = [
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "#",
        "field": "#",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "pinned": "left", "sort": null, "sortIndex": null, "rowDrag": true
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "ag-Grid-AutoColumn",
        "field": "primaryCol",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Primary Column",
        "suppressMovable": true, "lockPosition": true
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 1",
        "field": "Column1",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 1"
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 2",
        "field": "Column2",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 2"
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 3",
        "field": "Column3",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 3"
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 4",
        "field": "Column4",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 4"
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 5",
        "field": "Column5",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 5"
    },
]

const getSharedListInfo = async (sharedlistId,store) => {
    if (!sharedlistId) return null;
    let sheetLists=store.getState().userActivityReducer.sharedLists;
    if (sheetLists?.length > 0) {
        return sheetLists.find((list) => list.id === sharedlistId) || null;
    }
    else {
        let user=store.getState().userReducer.user
    const allSharedLists = await fetchSharedLists(user);
    return allSharedLists.find((list) => list.id === sharedlistId) || null;}
};
const getColumnData = async (type, values, sharedlistId, defaultstatus, isAzureColumn, store) => {
    let listData = '';
    let rollup = '';
    let linkedColumns;
    let sharedlistInfo = null;
    let defaultStatus;
  
    switch (type) {
      case 'dropdown':
      case 'dropdownsingle':
        listData = values || '';
        sharedlistInfo = await getSharedListInfo(sharedlistId, store);
        break;
  
      case 'multi dimensional value':
        listData = JSON.stringify(typeof values === "string" ? JSON.parse(values) : values || []);
        break;
  
      case 'shareableRollupList':
        listData = values || JSON.stringify([]);
        sharedlistInfo = await getSharedListInfo(sharedlistId, store);
        defaultStatus = defaultstatus;
        break;
  
      case 'person':
      case 'Assignee':
        listData = JSON.stringify(values || []);
        break;
  
      case 'number':
        rollup = values || '';
        break;
  
      case 'date':
        rollup = values?.rollup || '';
        if (values?.rollup !== "None")
          linkedColumns = values.linkedColumns ? values.linkedColumns : {};
        break;
  
      case 'duration':
        linkedColumns = values.linkedColumns
          ? values.linkedColumns
          : (values.endDate && values.startDate)
          ? { startDate: values.startDate, endDate: values.endDate }
          : {};
        break;
  
      case 'predecessor':
        linkedColumns = values ? orderPredecessorCol(values) : {};
        break;
  
      default:
        break;
    }
  
    return {
      listData,
      rollup,
      linkedColumns,
      sharedlistInfo,
      defaultStatus,
      ...(isAzureColumn && isAzureColumn!=="false" ? { azureColumn: isAzureColumn
      } : {}) // ✅ only include when true
    };
  };
  
const generateColumns = async (restOfColumns, columnTypes, columnNames, sheetInfo, store) => {
    for (const [index, item] of restOfColumns.entries()) {
        const columnType = columnTypes[index + 2];
        
        const { listData, rollup, linkedColumns, sharedlistInfo,defaultStatus,azureColumn } = await getColumnData(
            columnType.type,
            columnType.values,
            columnType.sharedlistId,
            columnType.defaultStatus,
            columnType.azureColumn,
            store
        );
        const column = {
            columnElasticid: `${uuidv4()}_es`,
            width: columnTypes[index + 2].width ? columnTypes[index + 2].width : "300",
            colId: item,
            field: item.split(" ").join(""),
            enableValue: true,
            enableRowGroup: true,
            groupDefaultExpanded: 1,
            filter: true,
            editable: true,
            resizable: true,
            autoHeaderHeight: true,
            wrapHeaderText: true,
            rowGroup: false,
            rowGroupIndex: null,
            pivot: false,
            pivotIndex: null,
            aggFunc: null,
            sort: null,
            sortIndex: null,
            headerName: columnNames[index + 2],
            type: columnTypes[index + 2].type,
            ...((rollup !== undefined && rollup !== null&&rollup!=='') && { rollup: rollup }),
            ...((linkedColumns !== undefined && linkedColumns !== null) && { linkedColumns: linkedColumns }),
            ...((defaultStatus !== undefined && defaultStatus !== null) && { defaultStatus: defaultStatus }),
            ...(azureColumn ? { azureColumn:azureColumn } : {}),
        };
        
        if(columnTypes[index + 2].type === "shareableRollupList"){
            column.status = true
        }
      
        if (listData.length > 0) {
            column.listData = listData;
        }   
      
        if (columnType?.sharedlistId?.length > 0) {
            column.sharedlistId =  columnType.sharedlistId;
            column.sharedlistInfo = sharedlistInfo;
        }
        sheetInfo.doc.columns.push(column);
}}
async function processProjectSheet(sheetInfo, sheetType, isImported, columns) {
        const isTemplate = !!columns?.length;
        columns = columns?.length ? columns : getProjectTemplateColumns();
        const { columns: cleanedColumns, position: tsPosition } = removeTimeSeriesColumns(columns);
        columns = cleanedColumns;

        const defaultStatusID = window.DEFAULT_STATUS_ID;
        const resp = await getSharedListById({ sharedlistId: defaultStatusID });
        let defaultStatusInfo = resp.data;

        if (!isTemplate || tsPosition !== null) {
            const { startDate, endDate } = getStartAndEndDate();
            const details = { startDate, endDate, frequency: "day" };
            const group = TimeSeriesColumngroup(details, columns, "", columns);

            let columnsToInsert = await deleteChildrenFromColumns(JSON.parse(JSON.stringify([group, ...group.children])));
            const position = tsPosition !== null ? tsPosition : columns.length - 1;

            columns = [...columns.slice(0, position), ...columnsToInsert, ...columns.slice(position)];
        }

        let sharelistOptions = typeof defaultStatusInfo.options === 'string' ? JSON.parse(defaultStatusInfo.options) : defaultStatusInfo.options;

        sheetInfo.doc.columns = columns.map(col => {
            const { template: _t, ...colWithoutTemplate } = col;
            const base = colWithoutTemplate;
            if (col.headerName === 'Status') {
                let sharedListOptions = sharelistOptions.map(option => ({
                    ...option,
                    value: option.value.replace(/[:-]/g, ' '), // replace special characters with space
                }));
                defaultStatusInfo.options = sharedListOptions;
                return { ...base, listData: JSON.stringify(sharedListOptions), sharedListInfo: defaultStatusInfo };
            }
            return base;
        });
}


 async function processSheetInfo({ 
        sheetIndex, sheetId, sheetName, workbook_id, workspace_id, l_id, 
        foundWorkbook, userData, sheetType, isImported, isTemplate, cols, parent, 
        sheetTypeSpecificInfo, columns, columnTypes, columnNames, store, referenceSheetId ,azureIntegrationInfo
    }) {
    const sheetInfo = {
        "index": sheetIndex,
        "doc": {
            "id": sheetId,
            "name": sheetName,
            "workbook_id": workbook_id,
            "workspace_id": workspace_id,
            "l_id": l_id,
            "user_email": foundWorkbook ? foundWorkbook.user_email : `${userData.email}`,
            "user_id": foundWorkbook ? foundWorkbook.user_id : `${userData.user_id || userData.email}`,
            "notes": "",
            "attachments": [],
            "sheetType": sheetType,
            "sheet_identifier": uuidv4(),
            parent,
             ...(isTemplate ? { copyOfOriginal: true } : {}),
            ...(isTemplate ? { sheet_scope: l_id.includes("publicTemplates")?"public":"private"} : {}),
            ...(azureIntegrationInfo ? {azureIntegrationInfo:JSON.stringify(azureIntegrationInfo)}:{}),
            ...sheetTypeSpecificInfo
        }
    };
    if (sheetType === 'project' && !isImported) {
        await processProjectSheet(sheetInfo, sheetType, isImported, cols);
    }
    else if(sheetType == 'checkinagent'){
        sheetInfo.doc.referenceSheetId = referenceSheetId
    }
     else if (sheetType === 'rolluplist') {
        sheetInfo.doc.columns = RollupListColumns;
    } else if (!cols && sheetType !== 'xPad') {
        // Sheet is not imported and manually created by us.
        if (!isImported)
            sheetInfo.doc.columns = [...defaultSheetColumns];
        else {
            // Sheet is imported by us making columns accordingly
            sheetInfo.doc.columns = defaultSheetColumns.slice(0, 2);
            let restOfColumns = columns.splice(2);
            await generateColumns(restOfColumns, columnTypes, columnNames, sheetInfo, store);
        }
    } else if (sheetType === 'xPad') {
        delete sheetInfo.doc.columns;
    }
    return sheetInfo;
}

const saveSheetData = async ({ rows, foundWorkbook, userData, columnGroups, reqBody, workbook_id, ELASTIC_URL, dispatch, ACTION_TYPES, callback }) => {
    if(!reqBody.doc.workbook_id){
        return
    }
    let sheetType= reqBody.doc.sheetType
    const rowData = rows ? makeSheetRowDataWithPreDefinedRows({ user_id: foundWorkbook ? foundWorkbook.user_id : userData.user_id || userData.email, user_email: foundWorkbook ? foundWorkbook.user_email : userData.email, workbook_id, rows, sheetType, newCols: reqBody.doc.columns }) : makeSheetRowData({ user_id: foundWorkbook ? foundWorkbook.user_id : userData.user_id || userData.email, user_email: foundWorkbook ? foundWorkbook.user_email : userData.email, workbook_id })
    if (reqBody.doc.sheetType !== 'xPad') reqBody.doc.Rows = rowData

    if (columnGroups && columnGroups.length > 0) {
        const colDefs = reqBody.doc.columns;

        const updatedColumns = processColumnsForColGrouping(colDefs, columnGroups)
        reqBody.doc.columns = updatedColumns
    }
    let response 
    try {
        if (!reqBody.doc.workbook_id) {
            renderAlert("Error in creating sheet, please refresh and try again","error")
            dispatch({ type: ACTION_TYPES.SET_FALLBACKERROR, fallbackerror: new Error("Workbook data invalid") })
            dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
             throw new Error("Workbook data invalid");
        }
        response = await POST(ELASTIC_URL + '/sheet/insertDoc', reqBody);
            if(response?.data){
                dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, updatedDateOfSheet: ''})
                dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, createdDateOfSheet: response?.data?.createdDate})
            }                
        console.log("Response from POST:", response); // Debugging log
       callback(response.data, reqBody);
    } catch (error) {
        console.error("Error in POST request:", error);
        return
    }

    dispatch({
        type: ACTION_TYPES.SET_WORKSPACE_DATA,
        rowDataEditor: {
            action: "addSheet",
            sheet: {
                id: reqBody.doc.id,
                name: reqBody.doc.name,
                workbook_id: reqBody.doc.workbook_id,
                user_id: reqBody.doc.user_id || userData.user_id || userData.email,
                user_email: reqBody.doc.user_email || userData.email,
                sheetType: reqBody.doc.sheetType || "default",
                parent: reqBody.doc.workbook_id,
                sheet_identifier: reqBody.doc.sheet_identifier,
                copyOfOriginal:reqBody.doc.copyOfOriginal,
                sheet_scope:reqBody.doc.sheet_scope,
                l_id : reqBody.doc.l_id,
                ...(reqBody.doc.workspace_id && { workspace_id: reqBody.doc.workspace_id })
            }
        }
    })
    reqBody.doc.name = response.data.sheetName
   
    localStorage.setItem('mD_' + response.data._id, JSON.stringify({ name: reqBody.doc.name, loggedInUser: userData.email, sheetOwner: reqBody.doc.user_email }))
    localStorage.setItem('mD_' + reqBody.doc.sheet_identifier, JSON.stringify({ name: reqBody.doc.name, loggedInUser: userData.email, sheetOwner: reqBody.doc.user_email }))
   
}
const prepareSheets = (sheetArray, rows, foundWorkbook, userData, workbook_id, columnGroups) => {
    return sheetArray.map(sheet => {
        const userId =foundWorkbook ? foundWorkbook.user_id : userData.user_id || userData.email;
        const userEmail = foundWorkbook ? foundWorkbook.user_email : userData.email;
        const rowData = rows ? makeSheetRowDataWithPreDefinedRows({ user_id: userId, user_email: userEmail, workbook_id, rows, sheetType: sheet.doc.sheetType, newCols: sheet.doc.columns }) : makeSheetRowData({ user_id: userId, user_email: userEmail, workbook_id });
        
        if (sheet.doc.sheetType !== 'xPad') sheet.doc.Rows = rowData;
        if (columnGroups?.length > 0) {
        const colDefs = sheet.doc.columns;
  
        const updatedColumns = processColumnsForColGrouping(colDefs, columnGroups)
        sheet.doc.columns = updatedColumns
    }
        
        return sheet;
    });
};
const saveSheetMetadata = (newSheetFromDB, sheet, userData) => {
    const metadata = JSON.stringify({
        name: sheet.doc.name,
        loggedInUser: userData.email,
        sheetOwner: sheet.doc.user_email
    });
    
    localStorage.setItem(`mD_${newSheetFromDB._id}`, metadata);
    localStorage.setItem(`mD_${sheet.doc.sheet_identifier}`, metadata);
};

const saveMultiSheetData = async ({ rows, foundWorkbook, userData, columnGroups, sheetArray, workbook_id, ELASTIC_URL, dispatch, ACTION_TYPES, callback, sheetListId, sheetList }) => {
    const sheetsToInsert = prepareSheets(sheetArray, rows, foundWorkbook, userData, workbook_id, columnGroups);
    let response
    try {
        let url = "/sheet/insertMultipleSheets"; // Assuming the endpoint accepts an array of sheets
        response = await POST(ELASTIC_URL + url, JSON.stringify(sheetsToInsert));

    } catch (error) {
        console.error("Error in POST request:", error);
    }

    let newSheetDataElasticFornavigation;
    let sheetListCopy = [...sheetList].reverse();
    // Check if the response is successful
    if (response && (response.error === undefined || response.error.statusCode === undefined)) {
        let newSheetsFromDB = response.data.sheets

        // Iterate over created sheets and update the list
        newSheetsFromDB.forEach((newSheetFromDB, index) => {
            if (!newSheetDataElasticFornavigation && sheetsToInsert[index].doc.sheetType === 'project') {
                newSheetDataElasticFornavigation = sheetsToInsert[index]
            }
            // Save metadata for the sheet
            saveSheetMetadata(newSheetFromDB, sheetsToInsert[index], userData);
        })
    }
    dispatch({
        type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {
            action: "addMultipleSheets",
            sheet: sheetListCopy
        }
    });
    callback(sheetListCopy, newSheetDataElasticFornavigation);
}

export const createSheetHelperForWorkSpaces = ({
    sheetName,
    sheetId,
    cols,
    rows,
    sheetType,
    sheetTypeSpecificInfo,
    workspace_id,
    l_id,
    workbook_id,
    parent,
    columns,
    columnNames,
    isImported,
    isTemplate,
    columnTypes = [],
    isWorkbooktemplate,
    newWorkbook_l_id,
    callback,
    columnGroups,
    sharedWithMeWorkBooks,
    azureIntegrationInfo
}) => async (dispatch) => {
    const { userData } = store.getState().userReducer
    const sheetIndex = window.SHEET_INDEX;
    const foundWorkbook = Array.isArray(sharedWithMeWorkBooks)
    ? sharedWithMeWorkBooks.find(workbook => workbook.id === workbook_id)
    : undefined;  
    let reqBody;
    let sheetArray=[]
    if (!isWorkbooktemplate) {
        reqBody = await processSheetInfo({
            sheetIndex,
            sheetId,
            sheetName,
            workbook_id,
            workspace_id,
            l_id,
            foundWorkbook,
            userData,
            sheetType,
            isImported,
            isTemplate,
            cols,
            parent,
            sheetTypeSpecificInfo,
            columns,
            columnTypes,
            columnNames,
            store,
            referenceSheetId: '',
            azureIntegrationInfo:azureIntegrationInfo
        });
        
        await saveSheetData({
            rows,
            foundWorkbook,
            userData,
            columnGroups,
            reqBody,
            workbook_id,
            ELASTIC_URL,
            dispatch,
            ACTION_TYPES,
            callback
        });
    }
    else {
        let projectTemplateSheet = await processSheetInfo({
            sheetIndex,
            sheetId,
            sheetName: "Sheet (1)",
            workbook_id,
            workspace_id,
            l_id,
            foundWorkbook,
            userData,
            sheetType: 'project',
            isImported,
            isTemplate,
            cols,
            parent,
            sheetTypeSpecificInfo,
            columns,
            columnTypes,
            columnNames,
            store,
            referenceSheetId: '',
            azureIntegrationInfo:azureIntegrationInfo
        });
        
        for (const type of ['checkinagent', 'xPad']) {
            let newsheetId= 'sh_' + uuidv4();
               let newSheetInfo = await processSheetInfo({
                sheetIndex, 
                sheetId: newsheetId, 
                sheetName: type === 'xPad' ? 'Sheet (2)' : 'CheckinagentInfo', 
                workbook_id, 
                workspace_id, 
                l_id: newWorkbook_l_id ? newWorkbook_l_id + "." + newsheetId : l_id,
                foundWorkbook, 
                userData, 
                sheetType: type, 
                isImported, 
                cols, 
                parent, 
                sheetTypeSpecificInfo, 
                columns, 
                columnTypes, 
                columnNames, 
                store, 
                referenceSheetId: projectTemplateSheet?.doc.id
            });
            
            sheetArray.push(newSheetInfo)
        }
        sheetArray.push(projectTemplateSheet)

        let sheetList =sheetArray.map(sheet=>sheet.doc)
        let sheetListId=sheetArray.map(sheet=>sheet.doc.id)
        await saveMultiSheetData({
            rows,
            foundWorkbook,
            userData,
            columnGroups,
            sheetArray,
            workbook_id,
            ELASTIC_URL,
            dispatch,
            ACTION_TYPES,
            callback,
            sheetListId,
            sheetList
        });  
    }
}

const orderPredecessorCol = (obj) => {
    const { predecessorStartDate, predecessorEndDate } = obj;
    return {
        predecessorStartDate,
        predecessorEndDate,
    };
}

const processColumnsForColGrouping = (columns, columnGroups) => {
    let colCopy = [...columns];
    columnGroups.forEach((col) => {
        if(!col.timeseries){
        const index = col.index;
        const { columnGroup, updatedChildrens } = groupColumns(col, colCopy);
        
       const firstChild = col.childrens[0];
       let finalIndex = index;
       if(firstChild.includes('||')){
        let nameAndField = firstChild.split('||')
        const colName = nameAndField[0];
        const field = nameAndField[1];
        finalIndex = colCopy.findIndex((colDef)=>(colDef.headerName === colName && colDef.field===field ))
       }else{
        finalIndex = colCopy.findIndex((colDef)=>colDef.headerName === firstChild)
       }
       
        colCopy.splice(finalIndex, 0, {
            ...columnGroup,
            children: updatedChildrens
        })
        }else{
            //logic for timeseries 
            const index = col.index;
            
            const { columnGroup, updatedChildrens } = groupColumnsForTimeSeries(col, colCopy)
            delete columnGroup.children
            //colCopy = colCopy.filter(colDef => !col.childrens.includes(colDef.headerName));
            colCopy.splice(index, 0, {
                ...columnGroup,
             
            })

        }
    });

    return colCopy;
}

const groupColumnsForTimeSeries=(column,columns)=>{
    
    const {groupName,childrens,startDate,endDate,frequency}=column;
    
    
    const start=new Date(startDate);
    const end=new Date(endDate);
    let groupId=uuidv4()
    let updatedChildrens=[]
    childrens.forEach((child,index) => {
        const colDef = columns.find(col => col.colId === child || col.headerName===child);
        if (colDef) {
            if(colDef.headerName==="Total"){
                colDef.block='timeseries'
                colDef.cellRenderer= 'multiDimensionalColumnRenderer'
                colDef.cellDataType= false
                colDef.cellEditor= 'multiDimensionalValueTypeEditor'
                colDef.listData=JSON.stringify(TotalColumnTimeSeriesListData)
                colDef.editable=false
                colDef.deleteable=true
                colDef.cellClass=getCellClass
                colDef.cellStyle =getCellStyle
                //colDef.valueGetter=(params)=>valueGetterForTotalTimeSeriesColumn(params,start,end)
                colDef.columnGroupShow='open'
                colDef.parent = groupId;
            }else{
                const day=dayjs(colDef.headerName)
                let isWeekend=day===0 || day===6
            colDef.parent = groupId;
            colDef.block='timeseries';
            colDef.cellClass =(params) => {
            let classArray=["global-style"]
            if(isWeekend) classArray.push('weekend')
            return classArray
        }
            SetTimeSeriesColumnProperties(colDef);
            if(index!=0){
                colDef.columnGroupShow='open'
            }
        }
        }
        updatedChildrens.push(colDef)
    });

    let columnGroup = {
        headerName:groupName,
        colId:groupId,
        columnElasticid:groupId,
        children: updatedChildrens,
        groupId:groupId,
        block:JSON.stringify({type:'timeseries',startDate:dayjs(startDate),endDate:dayjs(endDate),frequency:frequency})
    }


    return {columnGroup,updatedChildrens}

}

const groupColumns = (column, columns) => {
    const { groupName, childrens } = column;
    const groupId = uuidv4();
    
    const columnGroup = {
      headerName: groupName,
      columnElasticid: groupId,
      colId: groupId,
      groupId
    };
  
    const updatedChildrens = [];
  
    childrens.forEach((child, index) => {
      let colDef;
  
      if (child.includes('||')) {
        const parts = child.split('||');
        const name = parts[0];
        const field = parts[1];
        colDef = columns.find(col => col.colId === field && col.headerName === name);
        
        if (colDef) {
          colDef.parent = groupId;
          if (index !== 0) {
            colDef.columnGroupShow = 'open';
          }
        }
      } else {
        colDef = columns.filter(col => col.colId === child || col.headerName === child);
        
        if (colDef.length > 0) {
          colDef = colDef[0];
          colDef.parent = groupId;
          if (index !== 0) {
            colDef.columnGroupShow = 'open';
          }
        }
      }
  
      updatedChildrens.push(colDef);
    });
  
    return { columnGroup, updatedChildrens };
  };

  
  export const uploadExcelToOneDrive = (excelData, sheetListId, currentExportingWb, allWorkbooks, callback) => 
  async (dispatch) => {
    try {
      const { userData } = store.getState().userReducer;
      const isSharedWorkbook = userData.email !== currentExportingWb.user_email;

      const buffer = await excelData.xlsx.writeBuffer();
      const fileName = currentExportingWb.name;
      const formData = new FormData();

      const file = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      formData.append('file', file, `${fileName}.xlsx`);

      const filePath = isSharedWorkbook ? `Shared Workbooks/${fileName}` : fileName;
      formData.append('filePath', filePath);

      formData.append('workbook_id', currentExportingWb.id);
      formData.append('workbook_name', currentExportingWb.name);
      formData.append('isSharedWorkbook', isSharedWorkbook);
      formData.append('user_email',userData.email);

      if (sheetListId && sheetListId.length > 0) {
        formData.append('sheetList', sheetListId);
      }

      const res = await POST(`onedrive/uploadExcel`, formData);

      if (res) {
        if (!allWorkbooks) {
          let workbookUploadedMessage = "";

          if (currentExportingWb && currentExportingWb.name) {
            workbookUploadedMessage += `Workbook - ${currentExportingWb.name.slice(0, 25)}${
              currentExportingWb.name.length > 25 ? "..." : ""
            } `;
          }

          const isWbTemplate = currentExportingWb.sheetList.some(obj => obj.sheetType === "checkinagent");

          if( isWbTemplate && (currentExportingWb.sheetList.filter((sheet) => sheet.sheetType !== 'xPad').length !== checkSheetToDownloadInAWorkbook(currentExportingWb.sheetList).length)){
            workbookUploadedMessage += " CheckinagentInfo sheet not uploaded as WMT sheet does not have any Assignees "
          }

          workbookUploadedMessage += "Uploaded to OneDrive";
          renderAlert(workbookUploadedMessage, "success", '3000');
          dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, takeOneDriveBackup: false });
        }

        if (callback) {
            if (!allWorkbooks)
            callback()
        };
      }

      let { workbooksSyncedWithOneDrive } = store.getState().userActivityReducer;

      if (workbooksSyncedWithOneDrive) {
        workbooksSyncedWithOneDrive[currentExportingWb.id] = true;
        dispatch({
          type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,
          workbooksSyncedWithOneDrive,
        });
      }
    } catch (err) {
      throw new Error(err);
    }
  };


const uploadFile =  (formData, workbook) => async(dispatch) => {
    
    try {
        const res = await POST(`onedrive/uploadSheet`, formData);
        return res
    } catch (error) {
        // Handle error
        if (error.response) {
            // Server responded with a status other than 2xx
            console.error('Error response in sheet upload to onedrive:', error.response.data);
            // Display a user-friendly message
            if (error.response.status === 423) {
                renderAlert(error.response.data.message, "warning",3000)
            }
            else if(error.response.status === 404){
                renderAlert(error.response.data.message + ', Starting Workbook upload', "warning",3000);
                dispatch(startOneDriveUploadOfAWorkbook(workbook));
            }
            else if (error.response.data?.message !== 'Session is not latest' && typeof error.response.data?.message === 'string') {
                renderAlert(`Error: ${error.response.data.message}`,"error",3000);
            }
        } else if (error.request) {
            // Request was made but no response was received
            console.error('Error request:', error.request);
        } else {
            // Something happened in setting up the request
            console.error('Error message:', error.message);
        }
    }
};

const startOneDriveUploadOfAWorkbook = (workbook) => async (dispatch) => {
    try {
        let { currentDownladingWorkbook, exportWorkbook } = store.getState().workbookReducer;
        const { takeOneDriveBackup, isOneDriveConnected } = store.getState().userActivityReducer;
        const isExportingAlreadyOngoing = (takeOneDriveBackup && ((currentDownladingWorkbook && Object.keys(currentDownladingWorkbook).length > 0) || (exportWorkbook && Object.keys(exportWorkbook).length > 0)));
        if (!isExportingAlreadyOngoing && isOneDriveConnected) {
            dispatch({ type: ACTION_TYPES.DOWNLOAD_WORKBOOK, currentDownladingWorkbook: workbook })
            dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, takeOneDriveBackup: true })
        }

    } catch (error) {
        console.log('Error while uploading workbook', error);

    }

}

function getViewName(user_email) {
    const { accessInfoById } = store.getState().userActivityReducer

    let access = accessInfoById.find(item => item.user_id === user_email)
    if(access) return access.view
    return
}

export const updateSheetOfWorkbook = (gridRef, isSharedWorkbook) => async (dispatch) => {
    try {
         
        const { currentSelectedSheet } = store.getState().sheetReducer;
        if(currentSelectedSheet?.sheetType ==='filterSheet'){
            return ;
        }
        const { workbookListData, sharedWithMeWorkBooks } = store.getState().workbookReducer;
        const { updateSheetOfWorkbookOnOnedrive } = store.getState().userActivityReducer;
        //issue
        let sheetOfWorkbook;
        
        if (isSharedWorkbook) {
            sheetOfWorkbook = sharedWithMeWorkBooks?.find(workbook => workbook.id === currentSelectedSheet.workbook_id) ?? ''

        } else {
            sheetOfWorkbook = workbookListData?.find(workbook => workbook.id === currentSelectedSheet.workbook_id) ?? ''
        }
        let currentSelectedSheetLocalCopy = Object.assign(currentSelectedSheet)
        let currentSelectedWorkbookCopy = sheetOfWorkbook ? Object.assign(sheetOfWorkbook) : ''
        let { userData } = store.getState().userReducer;
        let owner = currentSelectedSheet.user_email === userData.email;
        const isSharedSheet = (!owner && !isSharedWorkbook);
        let viewName = getViewName(userData.email);
        let sheetName = isSharedSheet ? viewName || currentSelectedSheet.name : currentSelectedSheet.name
        const excelData = await createExcelJsWorkbook(gridRef, sheetName, '', currentSelectedSheet.sheetType, currentSelectedSheet.id, true);
        const buffer = await excelData.xlsx.writeBuffer();
        const { myCurrentSession } = store.getState().userReducer
        let fileName = sheetOfWorkbook?.name ?? ''
        const formData = new FormData()
        const file = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        formData.append('userSession', myCurrentSession)
        let res
        
        if (!owner && !isSharedWorkbook) {
            formData.append('file', file, viewName + '.xlsx');
            formData.append('filePath', "Shared Sheets/" + viewName)
            formData.append('workbook_id', currentSelectedSheet.id)
            formData.append('workbook_name', viewName)
            formData.append('sheet_id', currentSelectedSheet.id)
            formData.append('user_email', userData.email);
            formData.append('issharedworkbook', false);
            res = await POST(`onedrive/uploadSharedSheet`, formData);

        }
        else {
            formData.append('file', file, fileName + '.xlsx');
            if(isSharedWorkbook) {
            formData.append('filePath', 'Shared Workbooks/' + fileName)
            }else{
                formData.append('filePath', fileName)
            }
            formData.append('workbook_id', sheetOfWorkbook.id)
            formData.append('workbook_name', sheetOfWorkbook.name)
            formData.append('sheetName', cropStringIfNameExceeds31Chars(currentSelectedSheet.name))
            formData.append('sheet_id', currentSelectedSheet.id)
            formData.append('user_email', userData.email);
            formData.append('issharedworkbook', isSharedWorkbook);
            res = await dispatch(uploadFile(formData, sheetOfWorkbook));
        }
        if (res && res.data && res.data.success) {
            printSheetUploadMessage({ ...currentSelectedSheetLocalCopy, name: (owner || isSharedWorkbook) ? currentSelectedSheetLocalCopy.name : viewName }, { ...currentSelectedWorkbookCopy, name: isSharedWorkbook ? fileName : currentSelectedWorkbookCopy.name }, owner, isSharedWorkbook)
            if (updateSheetOfWorkbookOnOnedrive)
                dispatch({ type: ACTION_TYPES.SET_FLAGTOUPDATESHEETONONEDRIVE, updateSheetOfWorkbookOnOnedrive: false });
            if (owner) {
                let { workbooksSyncedWithOneDrive } = store.getState().userActivityReducer
                if (workbooksSyncedWithOneDrive) {
                    workbooksSyncedWithOneDrive[currentSelectedWorkbookCopy.id] = true
                    dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, workbooksSyncedWithOneDrive: workbooksSyncedWithOneDrive })
                }
            }
        }else if(res && res.data && !res.data.success){
            renderAlert(res.response.data.message,'warning',2000);
            dispatch({ type: ACTION_TYPES.SET_FLAGTOUPDATESHEETONONEDRIVE, updateSheetOfWorkbookOnOnedrive: false });
        }

    } catch (error) {
        
        console.log('Error updating sheet', error);

    }

}
export function printSheetUploadMessage(sheet, workbook, owner, isSharedWorkbook) {
    let sheetUploadedMessage ='';
    if(owner){
         sheetUploadedMessage += `Sheet - ${sliceNameto25Chars(sheet.name)} of Workbook - ${sliceNameto25Chars(workbook.name)}`;
    }else{
        if(isSharedWorkbook){
            sheetUploadedMessage += `Sheet - ${sliceNameto25Chars(sheet.name)} of Shared Workbook - ${sliceNameto25Chars(workbook.name)}`;
        }else{
        sheetUploadedMessage += `Shared Sheet - ${sliceNameto25Chars(sheet.name)}`
    };
    }
    sheetUploadedMessage += " Uploaded to OneDrive"
    renderAlert(sheetUploadedMessage, "success", 3000)
}

function sliceNameto25Chars (name) {
    return `${name.slice(0, 25) + (name.length > 25 ? "..." : "")}`
}
//fetchSheetListByWorkbookId
export const fetchSheetListByWorkbookId =async (workbookId, loggedInUser)=>{
    const sheetIndex = window.SHEET_INDEX;
    const res = await POST(`${ELASTIC_URL}/sheet/searchByWorkbookId`, { index: sheetIndex, workbook_id: `${workbookId}`, loggedInUser :`${loggedInUser}` })
    
    return res.data?.map((sh)=>{
        return {
            id: sh._id,
            ...sh._source
        }
    })
}
export const makeUpdatedUserWhileDataIsSaved=(lastUpdatedByUser)=>{
    let user_email = lastUpdatedByUser.split('-%')[0]
    return user_email + '-%' + new Date()
}
export const lockSheet = async(sheetId, user)  => {
    try {
        const {myCurrentSession}=store.getState().userReducer
        let latestSession = makeUpdatedUserWhileDataIsSaved(myCurrentSession)
        await POST(`${ELASTIC_URL}/sheet/update`, { sheetId: sheetId, doc: { locked:user,lastUpdatedByUser:latestSession,updated_date : new Date()} })
    }
    catch (e) {
        console.error("Error in updating sheet", e)
    }
}
export const updateSession = async (sheetId, sessionId, sessionUpdatedByUser) => {
    const timeStamp = new Date().toISOString();
    try {
      await POST(`${ELASTIC_URL}/sheet/update`, {
        sheetId,
        doc: { sessionId, timeStamp,sessionUpdatedByUser },
      });
    } catch (e) {
      console.error("Error updating session:", e);
    }
  };
export const isSheetUpdatedByOtherUser= async(sheetId) => {
    let result=await POST(`${ELASTIC_URL}/sheet/getRequiredFields`,{sheetId,fields:['locked','lastUpdatedByUser','user_email']})
    if(result && result.data){
        const {userData}=store.getState().userReducer
        let sheetSession=returnUserAndTimeStampFromLastUpdatedByUser(result.data.lastUpdatedByUser)
        let currentEditor=result.data.lastUpdatedByUser ?sheetSession.user :''
        if(currentEditor && currentEditor!==userData.email) return {locked:result.data.locked}
        else if((!currentEditor)|| (currentEditor===userData.email)){
            if(result.data.locked===null) lockSheet(sheetId,userData.email)
            return false
        }
        // else return {locked:result.data.locked}

    }
}
export const getIdAndWorkBookIdOfSheet=async(url)=>{
    const newLocation = url.includes('workbook-shared') ? url.split('sheet/workbook-shared') : url.includes('sheet/shared') ?  url.split('sheet/shared') : url.split('sheet/');
    const sheet_identifier = newLocation[1];
    let result=await POST(`${ELASTIC_URL}/sheet/getRequiredFieldsUsingSheetIdentifier`,{sheet_identifier,fields:['_id','workbook_id',"name","user_id", 'sheetType', 'deactivated', 'updateddate','namedFilters','template_id','hasOriginalTemplatesharedWithUser']})
    if(result && result.data){
        return {...result.data,sheet_identifier}
    }
}

export const getDeactivatedSheets = async (sheetIds) => {
    try {
        const sheetIndex = window.SHEET_INDEX;

        let res = await POST(`${ELASTIC_URL}/sheet/getDeactivatedSheets`, { index:sheetIndex, sheetIds: sheetIds })
        if (res && res.data) {
            return res.data
        }
    }
    catch (e) {
        console.error("Error in getting deactivated sheets", e)
        return []
    }

}


export const resetSheetReducer = () =>async(dispatch) => {
    dispatch({ type: ACTION_TYPES.RESET_SHEET_STATE })
}

export const fetchSheetListByWorkbookIds =async (workbooks)=>{
    let workbookIds= workbooks.map((wb)=>wb.id)
    const res = await POST(`${ELASTIC_URL}/sheet/getAllSheets`, {workbookIds})
   
    return res.data
}

export const setIsSheetDeleting = (isSheetDeleting) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_IS_WORKBOOK_DELETING, isSheetDeleting: isSheetDeleting })
}

export const updateCheckInAgentDataFromSheetAndSaveInSheet = async (sheetId, updatedCheckInAgentData) => {
    try {
        await POST(`${ELASTIC_URL}/sheet/update`, {
            sheetId,
            doc: { checkInAgentData: updatedCheckInAgentData },
        });
    } catch (error) {
        console.error("Error in emptyCheckInAgentDataFromSheet", error);
    }
}
export const updateAzureIngetionInfo = async (sheetId, azureInfo,disintegrateAzure,dispatch,currentSelectedSheet) => {
    // const timeStamp = new Date().toISOString();
    // let response = await POST(`${ELASTIC_URL}/sheet/update`, { sheetId: sheetId, doc: { globalStyle } })
    try {
        const updatedAzureInfo = disintegrateAzure
        ? ''
        : azureInfo
        ? JSON.stringify(azureInfo)
        : '';
      await POST(`${ELASTIC_URL}/sheet/update`, {
        sheetId,
        doc: { azureIntegrationInfo : updatedAzureInfo},
      });
     if(dispatch) dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: { ...currentSelectedSheet, azureIntegrationInfo: updatedAzureInfo,} })
    } catch (e) {
      console.error("Error updating session:", e);
    }
  }; 

  export const DefineTemplateOwner =(currentSelectedSheet)=>async(dispatch)=>{
    if(currentSelectedSheet.template_id && !currentSelectedSheet.templateOwner){
    const {templates} = store.getState().templateReducer;
    const originalTemplateOwner = templates?.find(
        t => t.template_id === currentSelectedSheet?.template_id
    );
      await POST(`${ELASTIC_URL}/sheet/update`, {
          sheetId: currentSelectedSheet.id,
          doc: {
              templateOwner: originalTemplateOwner?.user_id
          }
      });
    dispatch({
        type: ACTION_TYPES.SET_SHEET_DATA,
        currentSelectedSheet: {
            ...currentSelectedSheet,
            templateOwner: originalTemplateOwner.user_id,
        },
    });}

}